/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import { ComposeEmailParams } from '../../params/redux/email';
import { composeEmailThunk } from '../../redux/thunks/email';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import { fetchDealContactThunk } from '../../redux/thunks/contact';
import { gray } from '../../theme/themePrimitives';
import { KeyboardArrowLeft } from '@mui/icons-material';
import LabelWrapper from '../wrapper/label';
import { messageComposeSchema } from '../../schema/email_schema';
import { settingComposingFlagEmail } from '../../redux/slices/email';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Bounce, toast } from 'react-toastify';
import { Box, Button, Chip, ClickAwayListener, MenuItem, Paper, Popper, Typography } from '@mui/material';
import { emailAndPhoneOptions, fieldsOptions } from '../../helper';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';

interface QuillEditorRef {
  insertTextAtCursor: (text: string) => void;
}


const ComposeEmailComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { selectedDeal } = useSelector((state: RootState) => state.deal);
    const { contacts } = useSelector((state: RootState) => state.contact);
    const { selectedLead } = useSelector((state: RootState) => state.lead);
    const { loaders } = useSelector((state: RootState) => state.email);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [filteredEmails, setFilteredEmails] = useState<string[]>([]);
    const quillEditorRef = useRef<QuillEditorRef>(null);
    const isLeadPage = location.pathname.includes('/lead-management') || location.pathname.includes('/app/leads');
    const isDealOrSalesPage = location.pathname.includes('/app/deal') || location.pathname.includes('/sales-marketing');
    const initialValues: ComposeEmailParams = {
        to_email: isLeadPage ? [selectedLead?.email ?? ''] : [],
        body: '',
        clean_body: '',
        client_id: id ? parseInt(id as string, 10) : 0,
        subject: ''
    };
    useEffect(() => {
        // const selectedEmails = (initialValues.to_email || []).map((email) => email.toLowerCase());
        if (isDealOrSalesPage) {
            const rawEmails = [
                selectedDeal?.email || '',
                ...contacts.map((item) => item.contact_email)
            ].filter(Boolean) as string[];
            const seen = new Set<string>();
            const uniqueEmails = rawEmails.filter((email) => {
                const lower = email.toLowerCase();
                if (seen.has(lower)) return false;
                seen.add(lower);
                return true;
            });
            // Deal page & Sales-Marketing page: Include deal email + contacts
            // const contactEmails = contacts.map((con: ContactObject) => con.contact_email).filter(Boolean);
            // setFilteredEmails([selectedDeal?.email ?? '', ...contactEmails].filter(Boolean));
            setFilteredEmails(uniqueEmails);
        } else if (isLeadPage) {
            // Lead-management page: Only the lead's email, no contacts
            setFilteredEmails([selectedLead?.email ?? ''].filter(Boolean));
        }
    }, [contacts, selectedDeal, selectedLead]);
    useEffect(() => {
        const fetchContacts = async () => {
            try {
                await dispatch(fetchDealContactThunk()).unwrap();
            } catch (e) {
                //
            }
        };
        if (!isLeadPage) {
            fetchContacts();
        }
    }, []);
    const navigateBackHandler = () => {
        dispatch(settingComposingFlagEmail(false));
    };
    const submitEmail = async (values: any) => {
        const selectedEmailIndices: number[] = values.to_email;
        const selectedEmails = selectedEmailIndices
            .map((emailId) => filteredEmails[emailId])
            .filter(Boolean);
        if (values.to_email.length === 0) {
            toast.error('Select at least one recipient', {
                position: 'top-left',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                theme: 'dark',
                transition: Bounce
            });
            return;
        }
        try {
            const data: ComposeEmailParams = {
                to_email: isLeadPage ? values.to_email : selectedEmails,
                subject: values.subject,
                body: values.body,
                client_id: id ? parseInt(id as string, 10) : 0
            };
            await dispatch(composeEmailThunk(data)).unwrap();
            toast.success('Email sent successfully!', {
                theme: 'dark',
                position: 'top-left',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                transition: Bounce
            });
            navigateBackHandler();
        } catch (e) {
            //
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={messageComposeSchema}
            onSubmit={submitEmail}
        >
            {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => {
                const addEmail = (email: string) => {
                    if (isLeadPage) {
                        setFieldValue('to_email', [selectedLead?.email ?? '']);
                    } else if (email.trim() && !values.to_email?.includes(email)) {
                        setFieldValue('to_email', [...(values.to_email as string[]), email]);
                    }
                    setAnchorEl(null);
                };
                return (<Form>
                    <Box display="flex" flexDirection="column" gap={2}>
                        {/* Header */}
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Button variant="text" color="secondary" startIcon={<KeyboardArrowLeft />} disabled={loaders.isCreating} onClick={navigateBackHandler}>
                                Back
                            </Button>
                            <Typography variant="h4" color="textSecondary">Compose mail</Typography>
                            <Box></Box>
                        </Box>

                        {/* Email Input with Chips */}
                        <Box>
                            <LabelWrapper label="To:" />
                            {isLeadPage && <Box
                                p={1}
                                border={`1px solid ${gray[300]}`}
                                borderRadius={1}
                                display="flex"
                                alignItems="center"
                                flexWrap="wrap"
                                gap={1}
                            >
                                {/* Render selected emails as chips */}
                                {(values.to_email as string[]).map((email: string) => (
                                    <Chip
                                        key={email}
                                        label={email}
                                        onDelete={() => {
                                            if (!isLeadPage) {
                                                setFieldValue('to_email', values.to_email?.filter((e) => e !== email));
                                            }
                                        }}
                                        // onDelete={() => setFieldValue('to', values.to)}
                                        deleteIcon={<></>}
                                        color="primary"
                                        variant="outlined"
                                        sx={{
                                            padding: '15px 0',
                                            borderRadius: '5px'
                                        }}
                                    />
                                ))}
                            </Box>}

                            {/* Input Field for Typing Emails */}
                            {!isLeadPage && (
                                <CustomInput
                                    type="autocomplete"
                                    value={values.to_email}
                                    onChangeForAutoComplete={(newIds) => setFieldValue('to_email', newIds as string[])}
                                    options={filteredEmails.map((item, index) => ({
                                        id: index,
                                        name: item
                                    }))}
                                    componentsProps={{ popper: { disablePortal: true }}}
                                    placeholder="Choose some options..."
                                    fullWidth
                                />
                            )}

                            {/* Email Suggestions Popper */}
                            <Popper open={Boolean(anchorEl)} anchorEl={anchorEl} placement="bottom-start">
                                <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                                    <Paper sx={{ mt: 1, maxHeight: '200px', overflowY: 'auto', minWidth: '200px' }}>
                                        {filteredEmails.length === 0
                                            ? (<Typography p={2} color="gray">No results found</Typography>)
                                            : (
                                                filteredEmails.map((email, index) => (
                                                    <MenuItem key={index} onClick={() => addEmail(email)}>
                                                        {email}
                                                    </MenuItem>
                                                ))
                                            )}
                                    </Paper>
                                </ClickAwayListener>
                            </Popper>
                        </Box>

                        {/* Subject Field */}
                        <Box>
                            <Box display="flex" justifyContent="space-between" alignItems="end" mb={1}>
                                <LabelWrapper label="Subject:" />
                                <Box>
                                    <CustomDropdown
                                        options={(location.pathname.includes('/lead-management') || location.pathname.includes('/app/leads')) ? emailAndPhoneOptions : fieldsOptions}
                                        value=""
                                        placeholder="Add Field"
                                        disabled={loaders.isCreating}
                                        onChange={(e) => setFieldValue('subject', `${values.subject} [${e.target.value}]`)}
                                    />
                                </Box>
                            </Box>
                            <CustomInput
                                name="subject"
                                placeholder="Email Subject"
                                fullWidth
                                variant="outlined"
                                value={values.subject}
                                onChange={handleChange('subject')}
                                onBlur={handleBlur('subject')}
                                error={errors.subject && touched.subject}
                                disabled={loaders.isCreating}
                            />
                        </Box>

                        {/* Message Box */}
                        <Box width="100%" height="30vh" >
                            <Box display="flex" justifyContent="space-between" alignItems="end" mb={1}>
                                <LabelWrapper label="Message:" />
                                <Box>
                                    <CustomDropdown
                                        options={(location.pathname.includes('/lead-management') || location.pathname.includes('/app/leads')) ? emailAndPhoneOptions : fieldsOptions}
                                        value=""
                                        placeholder="Add Field"
                                        // onChange={(e) => setFieldValue('body', `${values.body} [${e.target.value}]`)}
                                        onChange={(e) => {
                                            const textToInsert = ` [${e.target.value}] `;
                                            quillEditorRef.current?.insertTextAtCursor?.(textToInsert);
                                        }}
                                        disabled={loaders.isCreating}
                                    />
                                </Box>
                            </Box>
                            <CustomInput
                                type="quill"
                                value={values.body}
                                name="body"
                                quillEditorRef={quillEditorRef}
                                placeholder="Type content here..."
                                disabled={loaders.isCreating}
                                error={errors.body && touched.body}
                                quillHeight="22vh"
                                onChangeForPhone={(value: string) => setFieldValue('body', value)}
                            />
                            {/* <CustomToolbar />
                            <ReactQuill
                                onChange={(content, delta, source, editor) => {
                                    setFieldValue('body', content);
                                }}
                                value={values.body}
                                placeholder="Type content here..."
                                modules={quillModule}
                                formats={quillFormats}
                                theme="snow"
                                readOnly={loaders.isCreating}
                                style={{
                                    height: '22vh',
                                    borderBottomLeftRadius: '10px',
                                    borderBottomRightRadius: '10px',
                                    border:  ? `1px solid ${red[300]}` : 'none'
                                }}
                            /> */}
                        </Box>

                        {/* Submit Button */}
                        <Box display="flex" justifyContent="end" gap={2} >
                            <Button variant="outlined" color="secondary" size="large" disabled={loaders.isCreating} onClick={navigateBackHandler}>Cancel</Button>
                            <Button type="submit" variant="contained" color="primary" size="large" disabled={loaders.isCreating}>
                                {loaders.isCreating ? 'Sending...' : 'Send'}
                            </Button>
                        </Box>
                    </Box>
                </Form>);
            }}
        </Formik>
    );
};

export default ComposeEmailComponent;
// <TextField
//    value={emailInput}
//    onChange={(event) => {
//        const typedEmail = event.target.value;
//        setEmailInput(typedEmail);
//        // eslint-disable-next-line max-len
//        const updatedEmails: string[] = isLeadPage
//            ? [selectedLead?.email].filter(Boolean) as string[]
//            : [
//                selectedDeal?.email || '',
//                ...contacts.map((item) => item.contact_email)
//            ].filter(Boolean) as string[];
//        const seen = new Set<string>();
//        const uniqueEmails = updatedEmails.filter((email) => {
//            const lower = email.toLowerCase();
//            if (seen.has(lower)) return false;
//            seen.add(lower);
//            return true;
//        });
//        setFilteredEmails(uniqueEmails?.filter((email) => email.toLowerCase().includes(typedEmail?.toLowerCase())));
//        setAnchorEl(event.target.value ? event.currentTarget : null);
//    }}
//    onFocus={(event) => {
//        // On focus, show all unique emails
//        const rawEmails: string[] = [
//            selectedDeal?.email || '',
//            ...contacts.map((item) => item.contact_email)
//        ].filter(Boolean);
//
//        const seen = new Set<string>();
//        const uniqueEmails = rawEmails.filter((email) => {
//            const lower = email.toLowerCase();
//            if (seen.has(lower)) return false;
//            seen.add(lower);
//            return true;
//        });
//
//        setFilteredEmails(uniqueEmails);
//        setAnchorEl(event.currentTarget);
//    }}
//    onBlur={() => setAnchorEl(null)}
//    onKeyDown={(event) => {
//        if (event.key === 'Enter' && emailInput.trim() !== '') {
//            event.preventDefault();
//            addEmail(emailInput.trim());
//        }
//    }}
//    disabled={loaders.isCreating}
//    placeholder={values.to_email?.length === 0 ? 'Enter email' : ''}
//    variant="standard"
//    InputProps={{ disableUnderline: true }}
//    sx={{ flex: 1, minWidth: '120px' }}
// />